// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// initial state
interface UpgradeState {
  error: Error | null;
  list: Units[];
  expend: Expend | null;
  benefit: Benefit;
}

const initialState: UpgradeState = {
  error: null,
  list: [],
  expend: null,
  benefit: {
    time_reduce: 0,
    unit_reduce: 0
  }
};

// ==============================|| SLICE - MENU ||============================== //

const calculate = (list: Units[], benefit: Benefit) => {
  let total_food = 0;
  let total_wood = 0;
  let total_ore = 0;
  let total_silver = 0;
  let total_time = 0;
  let total_power = 0;
  let unitList: Unit[] = [];

  const { unit_reduce, time_reduce } = benefit;
  list.forEach((units) => (unitList = unitList.concat(units.unit_list)));

  // total_xx  = (xxx * num) *(1- x%) -xxx_de(固定减免)
  unitList.forEach((unit) => {
    total_food += unit.food * (unit.count || 0);
    total_wood += unit.wood * (unit.count || 0);
    total_ore += unit.ore * (unit.count || 0);
    total_silver += unit.silver * (unit.count || 0);
    total_time += unit.build_time * (unit.count || 0);
    total_power += (unit.is_new_server ? unit.new_power : unit.power) * (unit.count || 0);
  });

  return {
    total_food: Math.ceil(total_food * (1 + unit_reduce)),
    total_wood: Math.ceil(total_wood * (1 + unit_reduce)),
    total_ore: Math.ceil(total_ore * (1 + unit_reduce)),
    total_silver: Math.ceil(total_silver * (1 + unit_reduce)),
    total_time: Math.ceil(total_time / (1 + time_reduce)),
    total_power
  };
};

const units = createSlice({
  name: "units",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getListSuccess(state, action) {
      state.list = action.payload.units_list || [];
      state.benefit = { unit_reduce: action.payload.unit_reduce || 0, time_reduce: action.payload.time_reduce || 0 };
    },

    setCount(state, action) {
      const { unitsType, unitId, count } = action.payload;
      const _list: Units[] = JSON.parse(JSON.stringify(state.list));

      _list.forEach((units, unitsIndex) => {
        if (units.units_type === unitsType) {
          units.unit_list.forEach((unit, unitIndex) => {
            if (unit.units_id === unitId) {
              _list[unitsIndex].unit_list[unitIndex].count = count;
            }
          });
        }
      });

      state.expend = calculate(_list, state.benefit);
      state.list = _list;
    },

    resetCount(state, action) {
      const { unitsType } = action.payload;
      const _list: Units[] = JSON.parse(JSON.stringify(state.list));

      _list.forEach((units, unitsIndex) => {
        if (units.units_type === unitsType) {
          units.unit_list.forEach((unit, unitIndex) => {
            _list[unitsIndex].unit_list[unitIndex].count = 0;
          });
        }
      });

      state.expend = calculate(_list, state.benefit);
      state.list = _list;
    },

    getExpendSuccess(state, action) {
      state.expend = action.payload;
    }
  }
});

export default units.reducer;

// Actions
export const { getListSuccess, setCount, resetCount } = units.actions;

export function getList() {
  return async () => {
    try {
      const response = await axios.post(`units/get`);

      if (response.data.code === 0) {
        dispatch(units.actions.getListSuccess(response.data.data));
      } else {
        dispatch(units.actions.getListSuccess({}));
      }
    } catch (error) {
      dispatch(units.actions.getListSuccess({}));
      dispatch(units.actions.hasError(error));
    }
  };
}

// export function getExpend(list: Units[], benefit: Benefit) {
//   return async () => {
//     try {
//       dispatch(units.actions.getExpendSuccess(calculate(list, benefit)));
//     } catch (error) {
//       dispatch(units.actions.hasError(error));
//     }
//   };
// }

// ----------------------------------------------------------------------

export interface Units {
  units_type: string;
  units_type_name: string;
  units_type_img: string;
  unit_list: Unit[];
}

export interface Unit {
  units_id: string;
  units_name: string;
  units_type: string;
  count: number;
  level: number;
  wood: number;
  food: number;
  ore: number;
  silver: number;
  build_time: number;
  power: number;
  new_power: number;
  is_new_server: boolean;
}

export interface Expend {
  total_wood: number;
  total_food: number;
  total_ore: number;
  total_silver: number;
  total_time: number;
  total_power: number;
}

export interface Benefit {
  unit_reduce: number;
  time_reduce: number;
}
